import { Injectable, inject } from '@angular/core';
import {
  ProcessParameterDefaultsResponse as GeneratedProcessParameterDefaults,
  ProcessParameterDefaultsService as ProcessParameterDefaultsApi,
} from '@6grain/masofa-monolith-api-client/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ProcessParameterDefaultsResponse {
  processKey: string;
  parameters: Record<string, unknown>;
  hasOverride: boolean;
  updatedAt: string | null;
}

/** Process parameter defaults through the generated common client. */
@Injectable({ providedIn: 'root' })
export class ProcessParameterDefaultsService {
  private readonly api = inject(ProcessParameterDefaultsApi);

  load(processKey: string): Observable<ProcessParameterDefaultsResponse> {
    return this.api.assignmentsProcessesProcessKeyParameterDefaultsGet(processKey).pipe(map(normalizeDefaults));
  }

  save(processKey: string, parameters: Record<string, unknown>): Observable<ProcessParameterDefaultsResponse> {
    return this.api.assignmentsProcessesProcessKeyParameterDefaultsPut(processKey, { parameters })
      .pipe(map(normalizeDefaults));
  }

  clear(processKey: string): Observable<ProcessParameterDefaultsResponse> {
    return this.api.assignmentsProcessesProcessKeyParameterDefaultsDelete(processKey).pipe(map(normalizeDefaults));
  }
}

function normalizeDefaults(row: GeneratedProcessParameterDefaults): ProcessParameterDefaultsResponse {
  const parameters = row.parameters;
  return {
    processKey: row.processKey ?? '',
    parameters: parameters && typeof parameters === 'object' ? parameters as Record<string, unknown> : {},
    hasOverride: row.hasOverride ?? false,
    updatedAt: row.updatedAt ?? null,
  };
}
